import { createSelector } from '@opengov/compose-app/reselect';

import { getEntitySubdomain } from '../../entity/selectors';
import { GoogleAnalyticsEffects } from '../googleAnalytics/effects';
import {
  getEntityIdentifier,
  getEntityProperties,
  getUserIdentifier,
  getUserProperties,
  makeFriendlyActionType
} from '../selectors';
import { analyticsSelector } from '../state';

import { SegmentEffects } from './effects';

export const selectTrackingInitializationEffectCreator = createSelector(
  getUserIdentifier,
  getUserProperties,
  getEntityIdentifier,
  getEntityProperties,
  (userIdentifier, userProps, entityIdentifier, entityProps) => {
    return async () => {
      if (userIdentifier && entityIdentifier && entityIdentifier !== '') {
        return Promise.all([
          SegmentEffects.identify({ userIdentifier, props: userProps }),
          SegmentEffects.group({ entityIdentifier, props: entityProps })
        ]);
      }
    };
  }
);

export const createTracker = stateEventPropertiesSelector =>
  createSelector(
    stateEventPropertiesSelector,
    (stateEventProperties: {}) => {
      return async ({ type: rawEventName, payload: props }) => {
        const eventName = makeFriendlyActionType(rawEventName);
        return Promise.all([
          GoogleAnalyticsEffects.track({ eventName, props: { ...stateEventProperties, ...props } }),
          SegmentEffects.track({ eventName, props: { stateEventProperties, props } })
        ]);
      };
    }
  );

export const getTrackerState = createSelector(
  getEntitySubdomain,
  selectedEntitySubdomain => ({ selectedEntitySubdomain })
);

export const trackWithState = createTracker(getTrackerState);

export const getActionsToTrack = createSelector(
  analyticsSelector,
  state => state.queuedActionsToTrack
);
